module.exports = __webpack_public_path__ + "img/ry_20.9c049820.png";